export const OHL = {
    name: 'DV 104A/5 TS NOVA PAZOVA - TS STARA PAZOVA',
    voltage: '110',
    regionCode: 'BGD', 
    stanice: [],
    position: 'N',
    stubovi: [
        { index: 1, name: 'P-01', lat: 44.9554 , lng: 20.1952, sys: 1, portal: true},
        { index: 2, name: '93/1', lat: 44.9555 , lng: 20.194, sys: 2},
        { index: 3, name: '93/2', lat: 44.9547 , lng: 20.1913, sys: 2},
        { index: 4, name: '93/3', lat: 44.9538 , lng: 20.1887, sys: 2},
        { index: 5, name: '93/4', lat: 44.953 , lng: 20.1861, sys: 2},
        { index: 6, name: '93/5', lat: 44.9523 , lng: 20.1845, sys: 2},
        { index: 7, name: '93/6', lat: 44.9514 , lng: 20.1824, sys: 2},
        { index: 8, name: '93/7', lat: 44.9501 , lng: 20.1792, sys: 2},
        { index: 9, name: '93/8', lat: 44.949 , lng: 20.1765, sys: 2},
        { index: 10, name: '93', lat: 44.9485 , lng: 20.1758, sys: 3},
        { index: 11, name: '94', lat: 44.9502 , lng: 20.1737, sys: 2},
        { index: 12, name: '95', lat: 44.9517 , lng: 20.1718, sys: 2},
        { index: 13, name: '96', lat: 44.9534 , lng: 20.1697, sys: 2},
        { index: 14, name: '97', lat: 44.9551 , lng: 20.1676, sys: 2},
        { index: 15, name: '98', lat: 44.9566 , lng: 20.1662, sys: 1},
        { index: 16, name: '99', lat: 44.9586 , lng: 20.167, sys: 1},
        { index: 17, name: '100', lat: 44.9611 , lng: 20.1679, sys: 1},
        { index: 18, name: '101', lat: 44.9625 , lng: 20.1683, sys: 1},
        { index: 19, name: '102', lat: 44.964 , lng: 20.1688, sys: 1},
        { index: 20, name: '103', lat: 44.9668 , lng: 20.1698, sys: 1},
        { index: 21, name: '104', lat: 44.9696 , lng: 20.1708, sys: 1},
        { index: 22, name: '105', lat: 44.9718 , lng: 20.1716, sys: 1},
        { index: 23, name: '106', lat: 44.9731 , lng: 20.1714, sys: 1},
        { index: 24, name: 'P05', lat: 44.9733 , lng: 20.1712, sys: 1, portal: true}
    ],
    rasponi: [
        { name: 'P-01 - 93/1', position: [{ lat: 44.9554 , lng: 20.1952 }, { lat: 44.9555 , lng: 20.194 }] },
        { name: '93/1 - 93/2', position: [{ lat: 44.9555 , lng: 20.194 }, { lat: 44.9547 , lng: 20.1913 }] },
        { name: '93/2 - 93/3', position: [{ lat: 44.9547 , lng: 20.1913 }, { lat: 44.9538 , lng: 20.1887 }] },
        { name: '93/3 - 93/4', position: [{ lat: 44.9538 , lng: 20.1887 }, { lat: 44.953 , lng: 20.1861 }] },
        { name: '93/4 - 93/5', position: [{ lat: 44.953 , lng: 20.1861 }, { lat: 44.9523 , lng: 20.1845 }] },
        { name: '93/5 - 93/6', position: [{ lat: 44.9523 , lng: 20.1845 }, { lat: 44.9514 , lng: 20.1824 }] },
        { name: '93/6 - 93/7', position: [{ lat: 44.9514 , lng: 20.1824 }, { lat: 44.9501 , lng: 20.1792 }] },
        { name: '93/7 - 93/8', position: [{ lat: 44.9501 , lng: 20.1792 }, { lat: 44.949 , lng: 20.1765 }] },
        { name: '93/8 - 93', position: [{ lat: 44.949 , lng: 20.1765 }, { lat: 44.9485 , lng: 20.1758 }] },
        { name: '93 - 94', position: [{ lat: 44.9485 , lng: 20.1758 }, { lat: 44.9502 , lng: 20.1737 }] },
        { name: '94 - 95', position: [{ lat: 44.9502 , lng: 20.1737 }, { lat: 44.9517 , lng: 20.1718 }] },
        { name: '95 - 96', position: [{ lat: 44.9517 , lng: 20.1718 }, { lat: 44.9534 , lng: 20.1697 }] },
        { name: '96 - 97', position: [{ lat: 44.9534 , lng: 20.1697 }, { lat: 44.9551 , lng: 20.1676 }] },
        { name: '97 - 98', position: [{ lat: 44.9551 , lng: 20.1676 }, { lat: 44.9566 , lng: 20.1662 }] },
        { name: '98 - 99', position: [{ lat: 44.9566 , lng: 20.1662 }, { lat: 44.9586 , lng: 20.167 }] },
        { name: '99 - 100', position: [{ lat: 44.9586 , lng: 20.167 }, { lat: 44.9611 , lng: 20.1679 }] },
        { name: '100 - 101', position: [{ lat: 44.9611 , lng: 20.1679 }, { lat: 44.9625 , lng: 20.1683 }] },
        { name: '101 - 102', position: [{ lat: 44.9625 , lng: 20.1683 }, { lat: 44.964 , lng: 20.1688 }] },
        { name: '102 - 103', position: [{ lat: 44.964 , lng: 20.1688 }, { lat: 44.9668 , lng: 20.1698 }] },
        { name: '103 - 104', position: [{ lat: 44.9668 , lng: 20.1698 }, { lat: 44.9696 , lng: 20.1708 }] },
        { name: '104 - 105', position: [{ lat: 44.9696 , lng: 20.1708 }, { lat: 44.9718 , lng: 20.1716 }] },
        { name: '105 - 106', position: [{ lat: 44.9718 , lng: 20.1716 }, { lat: 44.9731 , lng: 20.1714 }] },
        { name: '106 - P05', position: [{ lat: 44.9731 , lng: 20.1714 }, { lat: 44.9733 , lng: 20.1712 }] }
    ]
}
